import { render, staticRenderFns } from "./AddAffiliateModal.vue?vue&type=template&id=6d39cd81&"
import script from "./AddAffiliateModal.vue?vue&type=script&lang=js&"
export * from "./AddAffiliateModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAffiliateModal.vue?vue&type=style&index=0&id=6d39cd81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports